import { render, staticRenderFns } from "./showPingYiDialog.vue?vue&type=template&id=d58b5e4e&scoped=true&"
import script from "./showPingYiDialog.vue?vue&type=script&lang=js&"
export * from "./showPingYiDialog.vue?vue&type=script&lang=js&"
import style0 from "./showPingYiDialog.vue?vue&type=style&index=0&id=d58b5e4e&prod&lang=less&scoped=true&"
import style1 from "./showPingYiDialog.vue?vue&type=style&index=1&id=d58b5e4e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d58b5e4e",
  null
  
)

export default component.exports